export default "__VITE_ASSET__2281ac30__"